// extracted by mini-css-extract-plugin
export default {"quote":"QuoteDetail_quote__Mk9gJ","form-parent":"QuoteDetail_form-parent__i-6T1","comments-parent":"QuoteDetail_comments-parent__khT05","parent":"QuoteDetail_parent__1OMkZ"};